export const dateFormat = 'YYYY-MM-DD';
export const timeFormat = 'HH:mm:ss';

export const displayDateFormat = 'MMMM d, y';
export const displayTimeFormat = 'h:mm a';

export const dateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ss';
